import React from 'react';

const EmptyPersonIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 109 107" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M54.1552 53.5555C47.0147 53.5555 40.1667 50.746 35.1176 45.745C30.0685 40.744 27.2319 33.9613 27.2319 26.8888C27.2319 19.8164 30.0685 13.0336 35.1176 8.03265C40.1667 3.03168 47.0147 0.222168 54.1552 0.222168C61.2957 0.222168 68.1438 3.03168 73.1929 8.03265C78.242 13.0336 81.0785 19.8164 81.0785 26.8888C81.0785 33.9613 78.242 40.744 73.1929 45.745C68.1438 50.746 61.2957 53.5555 54.1552 53.5555ZM54.1552 73.5555C75.5996 73.5555 94.8431 77.3622 108.002 93.9755V106.889H0.308594V93.9755C13.4674 77.3555 32.7108 73.5555 54.1552 73.5555Z" fill="#88A3B2" fillOpacity="0.4" />
  </svg>
);

export default EmptyPersonIcon;
